// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1nofF","info":"Note_info__3Qf2Q","note":"Note_note__1hUku","actions":"Note_actions__10zV-"};